import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';

// Components we'll build one by one
import AdminHeader from '../../components/admin/AdminHeader';
import AdminSidebar from '../../components/admin/AdminSidebar';
import AdminHome from '../../components/admin/AdminHome';
import Members from './Members';
import Attendance from './Attendance';
import Costumes from './Costumes';
import Instruments from './Instruments';
import Fines from './Fines';
import Announcements from './Announcements';
import ClassSchedule from './ClassSchedule';
import PerformanceTracer from './PerformanceTracer';

const Dashboard = () => {
  const { member, logout, socket } = useAuth();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [activePage, setActivePage] = useState('home');
  
  useEffect(() => {
  if (socket) {
    socket.on('new_announcement', () => {
      console.log('New announcement!');
    });
  }
}, [socket]);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div style={styles.container}>
      {/* Header */}
      <AdminHeader
        member={member}
        onBurgerClick={() => setSidebarOpen(!sidebarOpen)}
        onLogout={handleLogout}
      />

      {/* Sidebar */}
      <AdminSidebar
        isOpen={sidebarOpen}
        activePage={activePage}
        setActivePage={setActivePage}
        onClose={() => setSidebarOpen(false)}
      />

      {/* Overlay when sidebar is open */}
      {sidebarOpen && (
        <div style={styles.overlay} onClick={() => setSidebarOpen(false)} />
      )}

      {/* Main Content */}
      <div style={styles.main}>
        {activePage === 'home' && <AdminHome member={member} setActivePage={setActivePage} />}
        {activePage === 'members' && <Members />}
        {activePage === 'attendance' && <Attendance />}
        {activePage === 'costumes' && <Costumes />}
        {activePage === 'instruments' && <Instruments />}
        {activePage === 'fines' && <Fines />}
        {activePage === 'announcement' && <Announcements />}
        {activePage === 'schedule' && <ClassSchedule />}
        {activePage === 'performance' && <PerformanceTracer />}
      </div>
    </div>
  );
};

const styles = {
  container: {
    minHeight: '100vh',
    background: '#f0f2f5',
    fontFamily: "'Segoe UI', sans-serif",
  },
  main: {
    marginTop: '65px',
    padding: '20px',
    minHeight: 'calc(100vh - 65px)',
  },
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(0,0,0,0.5)',
    zIndex: 998,
  },
};

export default Dashboard;